module.exports = __webpack_public_path__ + "img/dde7fb2.png";